import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CustomDropdownForum from '../../components/Inputs/CustomDropdownForum';
import SimpleSearch from '../../components/Search/SimpleSearch';
import Search from '../../components/Search/Search';

export default class ForumHeaderMobile extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.object.isRequired,
    handleSelectedCategoryChange: PropTypes.func.isRequired,
    searchQuery: PropTypes.string.isRequired,
    handleSearchQueryChange: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired,
    handleSearchEnterPress: PropTypes.func.isRequired,
    renderSearchButton: PropTypes.bool
  };

  render() {
    const {
      categories,
      selectedCategory,
      handleSelectedCategoryChange,
      searchQuery,
      handleSearchQueryChange,
      handleSearch,
      handleSearchEnterPress,
      renderSearchButton,
      children,
    } = this.props;
    return (
      <div className="mobile-show">
        <CustomDropdownForum
          mobile
          label="Текущая категория:"
          categories={categories}
          selectedCategory={selectedCategory}
          onChange={handleSelectedCategoryChange}
        />

        <Search
          placeholder="Поиск по разделу"
          searchQuery={searchQuery}
          handleSearch={handleSearch}
          handleSearchEnterPress={handleSearchEnterPress}
          handleSearchQueryChange={handleSearchQueryChange}
          className="mb15px"
          renderSearchButton={false}
        />

        {renderSearchButton && (
          <button className="btn w100pr" onClick={handleSearch}>
            Поиск
          </button>
        )}
      </div>
    );
  }
}
